import React from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { IProfitabilityFormHeaderProps } from './types';
import { profitabilityFormPrefix } from '../../../utils/form';
import { PROFITABILITY_FORM_NAMES } from '../../utils/form';

import styles from './ProfitabilityFormHeader.module.scss';

export const ProfitabilityFormHeader: React.FC<IProfitabilityFormHeaderProps> = ({ disabled }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id="profitabilityFormHeader.period"
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />

      <CurrencyUnitSelector
        name={concatWithDot(profitabilityFormPrefix, PROFITABILITY_FORM_NAMES.CURRENCY)}
        disabled={disabled}
      />
    </Box>
  );
};
